import axios from 'axios'
import WordpressRestURI from '@/helpers/WordpressRestURI.js'

export default {
  sendEmail: function (options) {
    options['url'] = WordpressRestURI.domainURI + 'ttapi/email/v1/send_mail'
    return axios(options)
  },
  updatePassword: function (id, password) {
    var userOptions = {
      method: 'POST',
      url: WordpressRestURI.domainURI + 'ttapi/thinktank_registration/v1/userValidate',
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        'id': id,
        'user_token': btoa(password)
      },
      json: true
    }

    return axios(userOptions)
  },
  createThinkTankUser: function (userDetails, password) {
    var userOptions = {
      method: 'POST',
      url: WordpressRestURI.domainURI + 'ttapi/thinktank_registration/v1/create_user',
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        'user_login': userDetails.userName,
        'user_pass': password,
        'user_email': userDetails.email,
        'first_name': userDetails.firstname,
        'last_name': userDetails.lastname,
        'role': 'thinktank',
        'department': userDetails.department,
        'country': userDetails.country,
        'employeeNumber': userDetails.employeenumber,
        'communities': userDetails.company
      },
      json: true
    }

    return axios(userOptions)
  },
  updateThinkTankUser: function (userDetails) {
    userDetails.url = WordpressRestURI.domainURI + 'ttapi/thinktank_registration/v1/updateusermeta'
    return axios(userDetails)
  },
  getLocalDbUserLookup: function (emailID) {
    return axios.get(WordpressRestURI.domainURI + 'ttapi/thinktank_myusers/v1/wpsearch/' + emailID)
  },
  getTotalGraduatedIdeas: function (authorID) {
    return axios.get(WordpressRestURI.domainURI + 'ttapi/graduated_ideas/v1/total_graduated/' + authorID)
  },
  getViewContent: function (endpoint) {
    return axios.get(WordpressRestURI.restURI + endpoint)
  },
  getCustomViewContent: function (endpoint) {
    return axios.get(WordpressRestURI.domainURI + 'ttapi/' + endpoint)
  },
  endpointWithAuthetication: function (options, endpoint) {
    options['url'] = WordpressRestURI.restURI + endpoint
    return axios(options)
  },
  getJWTToken: function (username, password) {
    return axios.post(
      WordpressRestURI.jwtURI,
      { username: username, password: password }
    )
  }
}



// WEBPACK FOOTER //
// ./src/helpers/WordpressRestAPI.js